import React from 'react'
import { connect } from 'react-redux'
import FileUploader from '../FileUploader'
import FilesActions from '../../Redux/FilesRedux'
import AttractionActions from '../../Redux/AttractionRedux'

class FormChangeBanner extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
      file: null,
      uploaded: false,
    }
  }

  _fileUploaded = (file) => {
    this.setState({file})
  }

  _submit = (event) => {
    event.preventDefault()
    let parsed = {
      wide: null,
      wide_mobile: null
    }
    if (this.props.banners) {
      parsed = {
        ...parsed,
        ...this.props.banners
      }
    }
    let banner_file = {...parsed}
    banner_file[this.props.bannerType] = this.state.file
    const form = {
      banner_file
    }

    const data = {
      id: this.props.attractionId,
      form
    }

    this.props.updateAttractionDetail(data)
    this.props.closeModal()
  }

  render() {
    const { bannerType, closeModal } = this.props

    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Change Banner ({ bannerType })</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className="form-group">
            <div className="row">
              <div className="col-3">
                <label htmlFor="image" className="control-label">Banner File (<span className="text-orange">{ bannerType === 'wide' ? '1049x433' : '375x269' }</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader setting={{ type: 'attraction-banner' }} onUploaded={(filename) => this._fileUploaded(filename)}/>
              </div>
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button type="button" className="btn btn-lg btn-secondary" onClick={() => closeModal()}>Close</button>
            <button type="submit" disabled={!this.state.file} className="btn btn-lg btn-primary ml-2">Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  uploadFiles: state.files
})

const dispatchToProps = (dispatch) => ({
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data)),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  reset: () => dispatch(FilesActions.filesUploadReset())
})

export default connect(stateToProps, dispatchToProps)(FormChangeBanner)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/FormChangeBanner.js